<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Picker</em>
				<span class="int_type_no_border mgr_5">
					<input
						type="text"
						ref="picker_barcode"
						v-model.trim="picker_barcode"
						class="tbl_int"
						style="width:154px;"
						placeholder="Scan Picker's Barcode"
						autofocus
						autocomplete="off"
						@keypress.enter="searchPicker()"
						@focus="picker_focus = true"
						@blur="picker_focus = false"
					/>
					<span class="int_type">
						<select v-model="picker_barcode" @change="pickerChanged()">
							<option :value="null">Select Staff</option>
							<!-- <option v-for="(staff, index) in wh_staff_list" :key="index" :value="staff.barcode">{{ staff.barcode }} | {{ staff.name }} ({{ staff.user_id }})</option> -->
							<option v-for="(staff, index) in wh_staff_list" :key="index" :value="staff.barcode">{{ staff.name }} ({{ staff.user_id }}) | {{ staff.barcode }}</option>
						</select>
					</span>
					<input type="text" v-model.trim="picker_name" class="tbl_int" style="color:blue;width:266px;" disabled />
					<!-- <template v-if="picker_id"
						><font color="blue">{{ picker_id }}</font> (<b>{{ picker_name }}</b
						>)</template
					> -->
				</span>
			</div>
			<div class="left_option" style="padding-top:5px;">
				<em class="lt_text">Sample No</em>
				<span class="int_type_no_border mgr_5">
					<input type="text" ref="sample_dn" v-model.trim="sample_dn" class="tbl_int" placeholder="Enter Sample No or Scan" autofocus autocomplete="off" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>

				<span v-if="sample.status_code == 'D'" style="margin-left:50px;">
					<a href="javascript:;" class="gray_bt" @click="salesmanPickup()">Salesman Pick Up</a>
				</span>
			</div>
		</div>
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<!-- <col style="width:400px;" /> -->
						<col style="width:120px;" />
						<col style="width:80px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Sample Request Date</th>
							<td>
								<input type="text" class="tbl_int ssm_int" v-model="sample.request_date" readonly />
							</td>
							<th>Sales Group</th>
							<td>
								<input type="text" class="tbl_int sm_int mgr_15" v-model="sample.sales_group_name" readonly />
								<a v-if="sample.sample_no" href="javascript:;" @click="openSample()">Sample Detail (Click)</a>
							</td>
						</tr>
						<tr>
							<th>Status</th>
							<td>
								<input type="text" class="tbl_int sm_int" :value="sample.status_code | sampleStatusName" readonly />
							</td>
							<template v-if="sample.status_code == 'P'">
								<th>Pickup</th>
								<td>
									<input type="text" v-model.trim="sample.pickup_date" class="tbl_int ssm_int" readonly />
									by {{ sample.pickup_user }} at {{ sample.pickup_dt | moment('HH:mm:ss') }}
								</td>
							</template>
						</tr>
						<tr>
							<th>Description</th>
							<td colspan="3">
								<input type="text" v-model.trim="sample.description" class="tbl_int" readonly />
								<!-- <div style="float:left;"><input type="text" v-model.trim="invoice.remark" class="tbl_int sm_int" @input="updateRemark" /></div>
								<div style="float:left;padding-left:5px;">
									<CodeSelect className="tbl_select" :codes="remarks" :width="60" :showDesc="false" v-model="remark" @set-code="setRemark" />
								</div> -->
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<table class="list_tbl">
			<thead>
				<tr>
					<th width="10%">Location Code</th>
					<th width="15%">Location Name</th>
					<th width="10%">Quantity</th>
					<th width="10%">Picker ID</th>
					<th width="15%">Picker Name</th>
					<th width="20%">
						Start Time
						<a v-if="modifiable && sample.status_code == 'R'" href="javascript:;" type="button" class="search_bt" style="margin-left:10px;margin-top:-5px;" @click="pickupStartBatch()">Start All</a>
					</th>
					<th width="20%">
						End Time
						<a v-if="modifiable && sample.status_code == 'R'" href="javascript:;" type="button" class="search_bt" style="margin-left:10px;margin-top:-5px;" @click="pickupCompleteBatch()">Complete All</a>
					</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="status in pickupStatuses" v-bind:key="status.location_code">
					<td class="al_left" style="padding-top:15px;padding-bottom:15px;">{{ status.location_code }}</td>
					<td class="al_left">{{ status.location_name }}</td>
					<td class="al_right">{{ status.quantity | commaSeparated }}</td>
					<td class="al_left">{{ status.picker_id }}</td>
					<td class="al_left">{{ status.picker_name }}</td>
					<td class="al_center">
						<template v-if="status.start_dt">
							{{ status.start_dt | moment('MM-DD-YYYY HH:mm:ss') }}
						</template>
						<template v-else-if="status.quantity">
							<a v-if="modifiable && false" href="javascript:;" type="button" class="search_bt" @click="pickupStart(status)">Start</a>
						</template>
					</td>
					<td class="al_center">
						<template v-if="status.end_dt">
							{{ status.end_dt | moment('MM-DD-YYYY HH:mm:ss') }}
						</template>
						<template v-else-if="status.start_dt">
							<a v-if="modifiable && false" href="javascript:;" type="button" class="search_bt" @click="pickupComplete(status)">Complete</a>
						</template>
					</td>
				</tr>
			</tbody>
		</table>

		<!-- <div class="view_bottom_bt">
			<a href="javascript:;" type="button" :class="invoice ? 'search_bt' : 'disable_bt'" @click="completePickUp()">Complete Pick Up</a>
		</div> -->

		<!-- <input type="hidden" id="barcode_data" />
		<input type="hidden" id="code-scan" /> -->
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSamplePickupCompleteBatch, apiSamplePickupStartBatch, apiSelectSample, apiUpdateSalesmanPickup } from '@/api/sales/sample.js';
import { apiSelectUser, apiSelectUserList } from '@/api/basicinfo/user.js';

export default {
	data: function() {
		return {
			backUri: '/',
			sample_dn: null,
			sample: {},
			itemList: [],

			searching: false,

			picker_barcode: null,
			picker_id: null,
			picker_name: null,

			pickupStatuses: [],
			wh_staff_list: [],

			picker_focus: true,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		pickerUpdatable() {
			if (!this.picker_id) return false;

			return this.pickupStatuses.filter(s => s.picker_id).length > 0 ? true : false;
		},
	},
	components: {
		//SoSelect,
		//CustomDatePicker,
		//PartnerSelect,
	},
	methods: {
		openSample() {
			let routeData = this.$router.resolve({ name: 'sampleDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sample_no: this.sample.sample_no } });
			window.open(routeData.href, 'herp_sample_detail');
		},
		async salesmanPickup() {
			const { data } = await apiUpdateSalesmanPickup({
				sample_no: this.sample.sample_no,
			});

			if (data.result) {
				this.$toast.success('Saved Successfully');
				this.search();
			} else {
				this.$toast.error(data.msg);
			}
		},
		isValid() {
			if (!this.picker_id) {
				this.$toast.error('Picker not specified');
				return false;
			}
			return true;
		},
		isCompletable(status) {
			//console.log(this.picker_id, status);
			if (this.picker_id != status.picker_id) {
				this.$toast.error('Picker is different. Update first.');
				return false;
			}

			return true;
		},
		isAllCompletable() {
			//console.log(this.pickupStatuses);
			var rv = true;
			var vm = this;
			this.pickupStatuses.forEach(s => {
				if (rv && s.picker_id && vm.picker_id != s.picker_id) {
					vm.$toast.error('Picker is different. Update first.');
					rv = false;
					return false;
				}
			});

			return rv;
		},
		pickerChanged() {
			//console.log(this.picker_barcode);
			if (this.picker_barcode) {
				//console.log(this.picker_barcode);
				this.searchPicker();
			}
		},
		async searchPicker() {
			if (!this.picker_barcode) return;

			const { data } = await apiSelectUser({
				barcode: this.picker_barcode,
			});
			//console.log(data.user);
			if (data.user) {
				this.picker_id = data.user.user_id;
				this.picker_name = data.user.name;
				//console.log(this.$refs.so_dn);
				this.$refs.sample_dn.focus();
			} else {
				this.$toast.error('Barcode : ' + this.picker_barcode + ' not found');
				this.picker_id = null;
				this.picker_name = null;
				this.picker_barcode = null;
			}
		},
		// async completePickUp() {
		// 	if (!this.invoice) return;
		// 	//console.log('Complete Pickup');
		// },
		reset() {
			this.picker_barcode = null;
			this.picker_name = null;
			this.sample = {};
			this.sample_dn = null;
			this.pickupStatuses = [];

			this.$refs.picker_barcode.focus();
		},
		setInvoice() {
			this.search();
		},
		async search() {
			if (this.searching) return;

			//this.searching = true;
			//console.log('search');
			if (!this.sample_dn) {
				this.$toast.error('Empty Sample No.');
				return;
			}

			this.searching = true;
			//console.log('Searching SO:', this.sono);
			const { data } = await apiSelectSample({
				//invoice_no: this.invoice.invoice_no,
				sample_dn: this.sample_dn,
				// status_code: 'P',
				for_pickup: true,
			});
			//console.log(data.sample);

			this.pickupStatuses = [];
			this.itemList = [];

			this.sample = data.sample;
			if (!this.sample) {
				this.$toast.error('Not found.');
				this.sample = {};
			} else {
				this.pickupStatuses = data.pickupStatusList;
				this.itemList = data.sampleItemList;
				//console.log(this.pickupStatuses);
			}
			this.searching = false;
			//console.log(this.invoice);
			//this.items = data.invoiceItemList;
			//this.selectInvoices();
		},
		async pickupStartBatch() {
			var valids = this.pickupStatuses.filter(l => l.quantity > 0 && !l.start_dt);

			if (valids.length > 0) {
				if (!this.isValid()) return;
				//console.log(valids);
				const { data } = await apiSamplePickupStartBatch({
					sample_no: this.sample.sample_no,
					items: valids,
					picker_id: this.picker_id,
				});

				if (data.result) {
					this.$toast.success('Saved Successfully');
					this.search();

					var vm = this;
					setTimeout(function() {
						vm.reset();
					}, 10000);
				} else {
					this.$toast.error(data.msg);
				}
			} else {
				this.$toast.error('Noting to process');
			}
		},
		async pickupCompleteBatch() {
			var valids = this.pickupStatuses.filter(l => l.start_dt && !l.end_dt);

			if (valids.length > 0) {
				if (!this.isValid()) return;
				if (!this.isAllCompletable()) return;
				//console.log(valids);
				const { data } = await apiSamplePickupCompleteBatch({
					sample_no: this.sample.sample_no,
					valid_items: valids,
					picker_id: this.picker_id,

					items: this.itemList,
				});

				if (data.result) {
					this.$toast.success('Saved Successfully');
					this.search();
					var vm = this;
					setTimeout(function() {
						vm.reset();
					}, 10000);
				} else {
					this.$toast.error(data.msg);
				}
			} else {
				this.$toast.error('Noting to process');
			}
		},

		async index() {
			// const { data } = await apiIndex();
			// this.locations = data.locationList;
			// console.log(this.locations);
		},
		async init() {
			let { data } = await apiSelectUserList({
				active_yn: 'Y',
				user_type: 'whstaff',
				sort_key: 'user_name',
			});

			this.wh_staff_list = data.userList;
			this.wh_staff_list.forEach(u => {
				u.barcode = u.barcode.substring(0, 10);
			});
			//console.log(this.wf_staff_list);
			//await this.index();
			//if (this.$route.query.sono) this.sono = this.$route.query.sono;
			//await this.selectInvoices();
		},
		barcodeScanned() {
			if (this.picker_focus) return;
			//console.log('Hm.....', this.barcode_data);
			var barcode_data = $('#barcode_data').val();

			if (barcode_data) {
				// if (this.invoice) {
				// 	console.log('search item');
				// } else {
				// 	this.sono = barcode_data;
				// 	this.search();
				// }
				this.so_dn = barcode_data;
				this.search();
			}
			//console.log('Hm.....', this.barcode_data);
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_sample_pickup');
		this.$store.commit('setSubTitle', 'Sales -> Sample Pick Up');

		//this.selectInvoices();
		this.init();

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();
		//initBarcodeScanner();
		//document.addEventListener('barcode_scanned', this.barcodeScanned);

		this.$refs.picker_barcode.focus();
	},
	destroyed() {
		//document.removeEventListener('barcode_scanned', this.barcodeScanned);
	},
};
</script>

<style></style>
